import { GET_CHARGER_LOG_GRAPH } from 'actions/chargerLogGraph';
const initialValues = {
  isLoading: true,
  graphDetail: '',
};

const chargerLogGraphReducer = (state = initialValues, { type, payload }) => {
  switch (type) {
    case GET_CHARGER_LOG_GRAPH.REQUEST: {
      return { ...state, isLoading: true };
    }

    case GET_CHARGER_LOG_GRAPH.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        graphDetail: payload,
      };
    }

    case GET_CHARGER_LOG_GRAPH.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};

export default chargerLogGraphReducer;
